/**
 * Globally-unique hotspot anchor names.
 *
 * Each value identifies a DOM mount point that an `OnboardingHotspot` or
 * `OnboardingInfoTooltip` can attach to. Targets are shared across flows:
 * multiple onboarding flows may attach hotspots to the same target, but the
 * string itself must be unique.
 *
 * Add new targets here as they're introduced. Group by feature area for
 * discoverability. Keep the right-hand string stable — changing it breaks
 * every consumer that already references it.
 */
export const HOTSPOT_TARGET = {
  // ---- Global nav ----
  CALLS_NAVIGATION_MENU: 'calls-navigation-menu',
  TOP_BAR_SETTINGS_ICON: 'top-bar-settings-icon',

  // ---- Call history ----
  CALL_HISTORY_CALL_INSIGHT_BUTTON: 'call-history-call-insight-button',

  // ---- Call insight panel ----
  CALL_INSIGHT_PANEL_TRANSCRIPT_TAB: 'call-insight-panel-transcript-tab',
  CALL_INSIGHT_PANEL_CALL_BREAKDOWN: 'call-insight-panel-call-breakdown',
  CALL_INSIGHT_PANEL_MAKE_CORRECTION_BUTTON: 'call-insight-panel-make-correction-button',
  CALL_INSIGHT_PANEL_SCHEDULING_OUTCOME_LABEL: 'call-insight-panel-scheduling-outcome-label',

  CALL_INSIGHT_PANEL_EDIT_AI_VIEW_LABEL: 'call-insight-panel-edit-ai-view-label',

  // ---- Patient profile ----
  PATIENT_CONTACT_AVATAR: 'patient-contact-avatar',
  PATIENT_PROFILE_LAST_CALL_CARD: 'patient-profile-last-call-card',
  PATIENT_PROFILE_VIEW_HISTORY_BUTTON: 'patient-profile-view-history-button',
  PATIENT_PROFILE_HISTORY_TAB_CALL: 'patient-profile-history-tab-call',

  // ---- Setting Page: User management ----
  SETTINGS_PAGE_USER_MANAGEMENT_GROUP: 'settings-page-user-management-group',

  // ---- Setting Page: User management ----
  ORGANIZATION_SETTINGS_USER_TABLE_ACTION_BUTTON: 'organization-settings-user-table-action-button',
} as const;
